module.exports = __webpack_public_path__ + "img/9.76294e69.jpg";